import { Button, Input, Modal, Select, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useState } from "react";
import axios from "axios";
import dayjs from "dayjs"
import phoneticFuntions from "../../SentenceManage/controller/phoneticFuntions";
import textToFile from "controllers/textToFile";
import s3Controller from "controllers/s3Controller";
import textToFile2 from "controllers/textToFile2";
import s3Controller2 from "controllers/s3Controller2";

const backend = process.env.REACT_APP_BACKEND;

function ControlBox ({baseParams, baseParamsHandler, pos, modalHandler, selectedRows, dataChangeHandlerForAll, stopRef, stopRefHandler, tableParams ,paginationHandler}) {

  const onSearch = (value) => {
    baseParamsHandler({
      ...baseParams,
      search: value
    })
    paginationHandler(1, tableParams.pagination.pageSize)
  }

  const posFilter = (value) => {
    baseParamsHandler({
      ...baseParams,
      pos: value
    })
    paginationHandler(1, tableParams.pagination.pageSize)
  }

  const cefrOption = [
    {value: "A0", label: "A0"},
    {value: "A1", label: "A1"},
    {value: "A2", label: "A2"},
    {value: "B1", label: "B1"},
    {value: "B2", label: "B2"},
    {value: "C1", label: "C1"},
    {value: "C2", label: "C2"},
  ]
  const cefrLevelEvpFilter = (value) => {
    baseParamsHandler({
      ...baseParams,
      cefrLevelByEVP: value
    })
    paginationHandler(1, tableParams.pagination.pageSize)
  }
  const cefrLevelGptFilter = (value) => {
    baseParamsHandler({
      ...baseParams,
      cefrLevelByGPT: value
    })
    paginationHandler(1, tableParams.pagination.pageSize)
  }

  const wordCountFilter = (value) => {
    baseParamsHandler({
      ...baseParams,
      wordCount: value
    })
    paginationHandler(1, tableParams.pagination.pageSize)
  }
  
  const createDiacritic = async () => {
    modalHandler("spin",true)
    modalHandler("progress",[0,selectedRows.length])
    for(let i=0; i<selectedRows.length; i++) {
      modalHandler("progress",[i+1,selectedRows.length])
      const instance = {...selectedRows[i]}
      const word = selectedRows[i].word
      const text = await phoneticFuntions.dotChange(word);
      
      const phoneticResult = await phoneticFuntions.getPhonetic(text);
      
      const changedValue = await phoneticFuntions.phoneticErrorChange(
        phoneticResult.data.data[0]
        );
        
      const convertedValue = changedValue.replaceAll(String.fromCharCode(160)," ")
      if(stopRef.current) break

      instance.diacritic = convertedValue
      dataChangeHandlerForAll(instance, "diacritic")

      const values = {
        id: instance.id, 
        word: instance.word,
        ContentSettingPartsOfSpeechMaster_code:instance.ContentSettingPartsOfSpeechMaster_code,
        diacritic: convertedValue
      }
      axios.patch(`${backend}/contents/new_word/word/list`,{values})
    }
    modalHandler("spin", false)
    modalHandler("progress",[0,0])
    stopRefHandler()
  }

  const createFile = async () => {
    modalHandler("spin",true)
    modalHandler("progress",[0,selectedRows.length])

    for(let i=0; i<selectedRows.length; i++) {
      if(stopRef.current) break
      if(!selectedRows[i].word) {
        const isContinue = () => {
          return new Promise((resolve)=> {
            Modal.confirm({
              title: "빈문장 에러",
              onCancel: () => {
                resolve(false)
              },
              onOk: () => {
                resolve(true)
              },
              okText: "계속",
              cancelText: "중지",
              content:
                selectedRows[i].id +
                "번 단어의 해석이 없어 파일을 생성할 수 없습니다. 나머지 단어를 계속 하시겠습니까? 아니면 중지하시겠습니까?",
            });
          })
        }
        if(await isContinue()) {
          continue
        } else {
          break
        }
      }

      modalHandler("progress",[i+1,selectedRows.length])
      const originRecord = JSON.parse(JSON.stringify(selectedRows[i]));
      const instance = {...selectedRows[i]};

      const speedNum = 1.0;
      const currentVer = dayjs(new Date()).format("YYYYMMDDHHmmss");

      const fileName = `word_${instance.id}_en_${currentVer}.mp3`;
      const text = instance.word;
      const name = '<voice name="en-US-EricNeural">';
      const speed = `<prosody rate="${speedNum}">`;

      const data = await textToFile2(
        text,
        name,
        speed,
        fileName,
        `word`
      );

      if (!data.Key) {
        const modalF = () => {
          return new Promise((resolve, reject) => {
            Modal.confirm({
              title: "서버에러",
              onCancel: () => {
                resolve(false);
              },
              onOk: () => {
                resolve(true);
              },
              okText: "계속",
              cancelText: "중지",
              content:
                instance.id +
                "번 단어에서 에러가 발생하였습니다. 나머지 파일을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
            });
          });
        };
        const modalResult = await modalF();
        if (modalResult) {
          continue;
        } else {
          break;
        }
      }

      const newKey = data.Key;
      const prefix = data.Key.split("_").slice(0, -1).join("_");

      const newFileName =
        data.key.split("/")[data.key.split("/").length - 1];

      instance.word_voice_filename = newFileName;
      // setFile(fileName)
      const values = {
        id: instance.id, 
        word: instance.word,
        ContentSettingPartsOfSpeechMaster_code:instance.ContentSettingPartsOfSpeechMaster_code,
        word_voice_filename: newFileName
      }
      dataChangeHandlerForAll(instance, "word_voice_filename")

      try{
        const axiosResult = await axios.patch(`${backend}/contents/new_word/word/list`, {values})
        if(axiosResult.status === 200) {
          const result = await s3Controller2.s3List(prefix);
  
          const files = result.Contents.reduce((acc, cur) => {
            if (cur.Key === newKey) {
              return acc;
            } else {
              acc.push({ Key: cur.Key });
              return acc;
            }
          }, []);
          if (files.length !== 0) {
            const result = await s3Controller2.s3DeleteFiles(files);
            // modalHandler("progress",[i+1,selectedRows.length])
          }
        }
      } catch (err) {
        const result = await s3Controller2.s3DeleteFile(newKey);
        const modalF = () => {
          return new Promise((resolve, reject) => {
            Modal.confirm({
              title: "서버에러",
              onCancel: () => {
                resolve(false);
              },
              onOk: () => {
                resolve(true);
              },
              okText: "계속",
              cancelText: "중지",
              content:
              instance.id +
              "번 단어에서 에러가 발생하였습니다. 나머지 파일을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
            });
          });
        };
        const errorResult = await modalF()
        dataChangeHandlerForAll(originRecord, "word_voice_filename")
        if(errorResult) {
          continue
        } else {
          break
        }
      }   
    }
    modalHandler("spin", false)
    modalHandler("progress",[0,0])
    stopRefHandler()
  }

  return (
    <Space wrap style={{justifyContent: "end"}}>
      <Input.Search
        placeholder="영어 문장을 입력하세요."
        onSearch={onSearch}
        allowClear={true}
        style={{
          width: 250,
          marginLeft: "5px",
        }}
      />
      <Select
        options={[{ value: "all", label: "품사: 전체" }, ...pos]}
        style={{ width: 150, textAlign: "left" }}
        defaultValue="all"
        value={baseParams.pos}
        onChange={posFilter}
      ></Select>
      <Select
        options={[{ value: "all", label: "CEFR 레벨(EVP): 전체" }, ...cefrOption]}
        style={{ width: 200, textAlign: "left" }}
        defaultValue="all"
        value={baseParams.cefrLevelByEVP}
        onChange={cefrLevelEvpFilter}
      ></Select>
      <Select
        options={[{ value: "all", label: "CEFR 레벨(GPT): 전체" }, ...cefrOption]}
        style={{ width: 200, textAlign: "left" }}
        defaultValue="all"
        value={baseParams.cefrLevelByGPT}
        onChange={cefrLevelGptFilter}
      ></Select>
      <Select
        options={[
          { value: "all", label: "단어장 수: 전체" },
          { value: 0, label: 0},
          { value: 1, label: 1},
          { value: 2, label: 2},
          { value: 3, label: 3},
          { value: 4, label: 4},
          { value: 5, label: 5},
          { value: 6, label: 6},
          { value: 7, label: 7},
          { value: 8, label: 8},
          { value: 9, label: 9},
          { value: 10, label: 10},
        ]}
        style={{ width: 150, textAlign: "left" }}
        defaultValue="all"
        value={baseParams.wordCount}
        onChange={wordCountFilter}
      ></Select>
      <Button onClick={()=>modalHandler("insertModal", true)}>
        <PlusOutlined />단어등록
      </Button>
      <Button onClick={createDiacritic} disabled={!selectedRows.length}>
        <PlusOutlined />발음기호 생성
      </Button>
      <Button onClick={createFile} disabled={!selectedRows.length}>
        <PlusOutlined />음성파일 생성(1.0)
      </Button>
    </Space>
  )
}

export default ControlBox